import { BOOK_FLIGHT, DELETE_FLIGHT } from "./actionType";

const initialState = {
  flights: [],
};

const flightBookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case BOOK_FLIGHT:
      const { id, from, to, date, guests, ticketClass } = action.payload;

      return {
        ...state,
        flights: [
          ...state.flights,
          {
            id,
            from,
            to,
            date,
            guests,
            ticketClass,
          },
        ],
      };

    case DELETE_FLIGHT:
      const newFlights = state.flights.filter(
        (flight) => flight.id !== action.payload
      );
      return {
        ...state,
        flights: newFlights,
      };

    default:
      return state;
  }
};

export default flightBookingReducer;
